var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, EmptyState, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useCreateDashboardWidget, useInsights, WidgetForm } from 'app/domains/insights';
export function EmptyGrid() {
    const { id } = useInsights();
    const [createWidget] = useCreateDashboardWidget();
    const { addToast } = useToast();
    const [open, setOpen] = useState(false);
    const closeModal = () => setOpen(false);
    const openModal = () => setOpen(true);
    const handleCreateWidget = (widget) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield createWidget(id, widget);
            closeModal();
            addToast({
                title: t({
                    message: 'Widget created',
                    comment: 'Insights: Toast message when widget is created',
                }),
                appearance: 'success',
            });
        }
        catch (error) {
            addToast({
                title: t({
                    message: 'Widget creation failed',
                    comment: 'Insights: Toast message when widget creation failed',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<Fragment>
      {open && <WidgetForm onClose={closeModal} onSubmit={handleCreateWidget}/>}
      <Box flexDirection="column" justifyContent="center">
        <EmptyState withAvatar icon={<Falcon icon="chart-line-up"/>} title={t({
            message: 'No widgets',
            comment: 'Insights: Title for when no widgets has been added to dashboard',
        })} description={t({
            message: 'Create your first widget',
            comment: 'Insights: Description for when no widgets has been added to dashboard',
        })} actions={<Button appearance="primary" onClick={openModal}>
              <Trans comment="Insights: Action for no created widgets">Create widget</Trans>
            </Button>}/>
      </Box>
    </Fragment>);
}
